<script>
import { CdrText } from '@rei/cedar';
import hoursMixin from '../../mixins/storeCommons';

export default {
  name: 'StoreAnnouncementComponent',
  components: {
    CdrText,
  },
  mixins: [hoursMixin],
  props: {
    storeData: {
      type: Object,
      required: true,
    },
  },
  computed: {
  },
};
</script>
<template>
  <div class="store-details__announcement ">
    <div
      v-for="specialMessage in getSpecialMessagesBelowStoreImage()"
      :key="specialMessage.name"
      class="store-data__special-message"
    >
      <cdr-text
        tag="h2"
        data-ui="special-message-title"
        class="store-info-title store-data__special-message"
      >
        {{ specialMessage.name }}
      </cdr-text>

      <div
        class="store-data__special-message"
        data-ui="store-special-message"
        v-html="getCustomerNotesHtml(specialMessage)"
      />
    </div>
  </div>
</template>
